<template>
  <div>
    <b-modal id="schlocation" centered :hide-footer="true" :hide-header="true">
      <!-- <Rating/> -->
      <span>
        <l-map
          :zoom="zoom"
          :center="center"
          :options="mapOptions"
          @update:zoom="zoomUpdated"
          @update:bounds="boundsUpdated"
          style="height: 350px; width: 100%"
        >
          <l-tile-layer :url="url" />
          <l-control-attribution
            position="topright"
            :prefix="this.attributionPrefix"
          />
          <l-control-zoom position="bottomright"></l-control-zoom>
          <l-marker :lat-lng.sync="center" :draggable="true">
            <LIcon
              :icon-size="[34, 40]"
              :icon-anchor="[17, 40]"
              :popupAnchor="[0, -32]"
              :icon-url="require('@/assets/map-marker.svg')"
            />
            <l-popup :lat-lng="center">
              <div class="text-center">
                <h6 class="m-0">Selected Location</h6>
                <small>{{ center }}</small>
              </div>
            </l-popup>
          </l-marker>
        </l-map>
      </span>
    </b-modal>
    <b-modal
      id="newschoolform"
      size="lg"
      centered
      :hide-footer="true"
      :hide-header="true"
    >
      <!-- <div class="container d-flex justify-content-center align-items-center p-0">
      <div class="card my-4 shadow p-1 bg-white rounded" style="width: 40rem;">-->
      <div class="text-center">
        <!-- <h1 class="m-0" style="font-size: 60px;"><b style="color: #7BBC9A; font-size: 80px;">I</b>kolilu</h1> -->
        <h2 class="mb-0 bg-light">Add New School</h2>
      </div>
      <div class="card-body">
        <form
          id="schoolform"
          enctype="multipart/form-data"
          v-on:submit.prevent="createNewSchool()"
        >
          <div class="form-group text-left">
            <div class="row">
              <div class="col">
                <label>School Name</label>
                <input
                  v-model="provider.sz_orgname"
                  name="sz_orgname"
                  type="text"
                  class="form-control"
                  placeholder="School"
                  required
                />
              </div>
              <div class="col">
                <label>Address</label>
                <input
                  v-model="provider.sz_address"
                  name="sz_address"
                  type="text"
                  class="form-control"
                  placeholder="School Address"
                  required
                />
              </div>
            </div>
          </div>
          <div class="form-group text-left">
            <div class="row">
              <div class="col">
                <label>Search Alias</label>
                <input
                  v-model="provider.sz_alias"
                  name="sz_alias"
                  class="form-control"
                  placeholder="School Alias"
                  required
                />
              </div>
              <div class="col">
                <label>Location</label>
                <input
                  v-model="provider.sz_location"
                  name="sz_location"
                  class="form-control"
                  placeholder="School Location. e.g. Kumasi or Tema"
                />
              </div>
            </div>
          </div>
          <div class="form-group text-left">
            <label>Contact Person</label>
            <input
              v-model="provider.sz_contactname"
              name="sz_contactname"
              type="text"
              class="form-control"
              placeholder="Name"
              required
            />
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group text-left">
                <label>Phone Number</label>
                <input
                  v-model="provider.sz_contactphoneno"
                  name="sz_contactphoneno"
                  type="text"
                  class="form-control"
                  placeholder
                  required
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group text-left">
                <label for>Contact Email</label>
                <input
                  v-model="provider.sz_contactemail"
                  name="sz_contactemail"
                  type="email"
                  aria-describedby="emailHelp"
                  class="form-control"
                  required
                />
              </div>
            </div>
          </div>
          <div class="form-group text-left">
            <label for>Geolocation</label>
            <div class="row align-items-center">
              <div class="col-9 custom-file">
                <div class="row align-items-center">
                  <div class="col">
                    <input
                      type="text"
                      v-model="center.lat"
                      name="lat"
                      class="form-control"
                      placeholder="lat"
                      readonly
                    />
                  </div>
                  <div class="col">
                    <input
                      type="text"
                      v-model="center.lng"
                      name="lng"
                      class="form-control"
                      placeholder="lng"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="col-3">
                <a class="btn btn-primary" v-b-modal="'schlocation'">
                  <i class="fa fa-map-marked-alt"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="form-group text-left">
            <label>GhanaPost GPS</label>
            <input
              type="text"
              class="form-control"
              name="sz_ghpostgps"
              placeholder="eg. WS-445-987"
              v-model="provider.sz_ghpostgps"
            />
          </div>
          <div class="form-group text-left">
            <label for>KYC</label>
            <div class="custom-file">
              <input
                class="custom-file"
                type="file"
                id="kycfile"
                name="kycfile"
                ref="uploadFile"
                accept=".pdf, .png"
                v-on:change="handleFileUpload()"
              />
            </div>
          </div>
          <div class="form-group text-left">
            <label for>Mobile Wallet</label>
            <div class="row">
              <div class="col-4">
                <select
                  name="phone-code"
                  id="phone-code"
                  class="form-control"
                  v-model="provider.szwalletprovider"
                >
                  <option></option>
                  <option value="MTN" data-thumbnail="@/assets/mtn.png">
                    MTN
                  </option>
                  <option
                    value="Vodafone"
                    data-thumbnail="@/assets/vodafone.png"
                  >
                    Vodafone
                  </option>
                  <option value="AirtelTigo" data-thumbnail="@/assets/air.png">
                    AirtelTigo
                  </option>
                </select>
              </div>
              <div class="col-8">
                <input
                  v-model="provider.szwalletnumber"
                  name="szwalletnumber"
                  class="form-control"
                  type="tel"
                  placeholder
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group text-left">
                <label for>Bank</label>
                <select
                  id="sz_bank"
                  class="form-control"
                  v-model="provider.sz_bank"
                  name="sz_bank"
                  @input="getBranch"
                >
                  <option value>Select Bank</option>
                  <option
                    v-for="(bank, i) in banks"
                    :value="bank.szbankid"
                    :key="i"
                  >
                    {{ bank.szbankname }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="form-group text-left">
                <label for>Branch</label>
                <select
                  id="sz_branchid"
                  name="sz_branchid"
                  class="form-control"
                  v-model="provider.sz_branchid"
                >
                  <option value>Select Branch</option>
                  <option
                    v-for="(branch, i) in branches"
                    :value="branch.szsortcode"
                    :key="i"
                  >
                    {{ branch.szbranchname }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group text-left">
            <label>Account Number</label>
            <input
              v-model="provider.sz_acctno"
              name="sz_acctno"
              type="text"
              class="form-control"
              placeholder
            />
          </div>
          <p>
            <small class="text-muted">
              By clicking "Save School", you agree to the iKolilu Providers
              Portal
              <a href="#">Terms and Conditions</a> and
              <a href="#">Privacy Policy</a>.
            </small>
          </p>
          <span class="animated fadeIn">
            <button
              type="submit"
              class="btn btn-outline-primary"
              :disabled="loading"
              style="border-radius: 25px"
            >
              <i v-if="loading" class="fa fa-spin fa-spinner"></i>
              <template v-else>SAVE SCHOOL</template>
            </button>
          </span>
          <span class="mx-2">
            <!-- <button class="btn btn-light px-3" >
                            Cancel
            </button>-->
          </span>
        </form>
        <textarea style="display: none" id="base64" rows="5"></textarea>
      </div>
      <!-- </div>
      </div>-->
    </b-modal>
    <div class="card-title">
      <div class="row">
        <div class="col py-4 text-left px-4 mx-2">
          <button type="button" class="btn btn-light px-1">
            All Schools
            <span class="badge badge-primary" style="font-size: 12px">{{
              tabdata.length
            }}</span>
          </button>
        </div>
        <div class="col py-4 text-right px-4 mx-2">
          <button
            type="button"
            class="btn btn-primary"
            v-b-modal="'newschoolform'"
            style="border-radius: 25px"
          >
            <i class="fa fa-plus-circle" aria-hidden="true"></i> Add School
          </button>
        </div>
      </div>
    </div>
    <div class="card mb-4">
      <div class="card-body">
        <div class="input-group md-form form-sm form-2 pl-0">
          <input
            class="form-control my-0 py-1 pl-3"
            style="border-radius: 30px"
            type="text"
            v-model="this.search"
            placeholder="Search school here..."
            aria-label="Search"
          />
        </div>
        <div class="text-center py-2" v-if="this.search">
          <span class="badge badge-pill badge-primary">
            {{ this.search }}
            <span class="remove-search-btn px-2" @click="removeComplaint(i)"
              >&times;</span
            >
          </span>
        </div>
        <div id="mySidenav" class="card sidenav text-center">
          <a href="javascript:void(0)" class="closebtn" @click="closeNav()"
            >&times;</a
          >
          <div v-if="theData.length !== 0">
            <div class="employeeInfo">
              <div
                class="card mx-1 mb-3"
                style="border-radius: 20px 20px 20px 20px"
              >
                <h1
                  class="text-center mdb-color lighten-5"
                  v-if="theData.length !== 0"
                >
                  {{ theData[selectedIndex].sz_orgname }}
                </h1>
                <div class="d-flex justify-content-between text-center mt-1">
                  <div class="col-4">
                    <h5>ID</h5>
                    <p>{{ theData[selectedIndex].Sz_orgid }}</p>
                  </div>
                  <div class="col-8">
                    <h5>Address</h5>
                    <p>{{ theData[selectedIndex].sz_address }}</p>
                  </div>
                </div>
              </div>
              <h4 class="text-center py-2 bg-white">CONTACT</h4>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">NAME</th>
                      <th scope="col">NUMBER</th>
                      <th scope="col">EMAIL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ theData[selectedIndex].sz_contactname }}</td>
                      <td>{{ theData[selectedIndex].sz_contactphoneno }}</td>
                      <td>{{ theData[selectedIndex].sz_contactemail }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr />
              <div>
                <p>
                  <b>Mobile Wallet:</b>
                  {{ theData[selectedIndex].szwalletnumber }}
                </p>
              </div>
              <hr />
              <h4 class="text-center py-2 bg-white">BANK DETAILS</h4>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">BANK</th>
                      <th scope="col">BRANCH</th>
                      <th scope="col">ACCT. NUMBER</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ theData[selectedIndex].sz_bank }}</td>
                      <td>{{ theData[selectedIndex].sz_branchid }}</td>
                      <td>{{ theData[selectedIndex].sz_acctno }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <!--Table-->
          <table class="table table-hover">
            <!--Table head-->
            <thead class="mdb-color darken-3 z-depth-2">
              <tr class="text-white">
                <th>#</th>
                <th scope="col" v-for="(header, index) in headers" :key="index">
                  {{ header.text }}
                </th>
              </tr>
            </thead>
            <!--Table head-->
            <!--Table body-->
            <tbody>
              <tr v-for="(detail, i) in theData" :key="i">
                <th scope="row">{{ i + 1 }}</th>
                <td class="py-3">{{ detail.Sz_orgid | capitalize }}</td>
                <td class="py-3 px-2" style="cursor: pointer">
                  {{ detail.sz_orgname | capitalize }}
                </td>
                <!-- <td class="py-3 px-2">{{detail.address}}</td> -->
                <td class="py-3 px-2">
                  {{ detail.sz_contactname | capitalize }}
                </td>
                <td class="py-3 px-2">{{ detail.sz_contactemail }}</td>
                <td class="py-3 px-2">
                  {{ detail.sz_contactphoneno | capitalize }}
                </td>
                <td class="text-center align-items-center mt-2">
                  <i
                    @click="openNav(i)"
                    class="fas fa-angle-right"
                    style="font-size: 20px"
                  ></i>
                </td>
              </tr>
            </tbody>
            <!--Table body-->
          </table>
          <div class="text-center mt-2" v-if="loading">
            <i
              style="font-size: 80px"
              class="fa fa-spinner fa-pulse fa-3x fa-fw"
            ></i>
          </div>
          <p
            v-if="tabdata.length === 0 && !loading"
            class="text-muted text-center lead font-weight-bold mt-2"
          >
            Please no data in selected school
          </p>
        </div>
        <div class="d-flex justify-content-center">
          <!--Pagination -->
          <nav class="my-4 pt-2">
            <ul class="pagination pagination-circle pg-blue mb-0">
              <!--Arrow left-->
              <li
                class="page-item"
                :class="{ disabled: currPage === 1 }"
                @click.prevent="setPage(currPage - 1)"
              >
                <a class="page-link" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                  <span class="sr-only">Previous</span>
                </a>
              </li>
              <!--Numbers-->
              <li
                class="page-item"
                v-for="(n, i) in totalPage"
                :key="i"
                :class="{ active: currPage === n }"
                @click.prevent="setPage(n)"
              >
                <a class="page-link">{{ n }}</a>
              </li>
              <!--Arrow right-->
              <li
                class="page-item"
                :class="{ disabled: currPage === totalPage }"
                @click.prevent="setPage(currPage + 1)"
              >
                <a class="page-link" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                  <span class="sr-only">Next</span>
                </a>
              </li>
            </ul>
          </nav>
          <!--/Pagination -->
        </div>
        <!--Table-->
      </div>
    </div>
  </div>
  <!-- Modal Form -->
</template>

<script>
import http from "@/network/Base.js";
import { mapState } from "vuex";
import { latLng } from "leaflet";
// import {mapState} from 'vuex';
// import EmployeeService from '@/network/corporate/employee.js'
import {
  LMap,
  LTileLayer,
  LMarker,
  LControl,
  LControlZoom,
  LFeatureGroup,
  LPopup,
  LIcon,
  LControlAttribution,
} from "vue2-leaflet";
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LControlZoom,
    LFeatureGroup,
    LPopup,
    LIcon,
    LControlAttribution,
  },

  data() {
    return {
      loading: false,
      search: "",
      selectedIndex: 0,
      newtabdata: [],
      tabdata: [],
      depend: [],
      headers: [
        { text: "ID", value: "id", align: "center" },
        { text: "SCHOOL", value: "school", sortable: true },
        // { text: "ADDRESS", value: "address" },
        { text: "CONTACT PERSON", value: "name" },
        { text: "EMAIL", value: "email" },
        { text: "NUMBER", value: "phoneno" },
        { text: "", value: "avatar" },
      ],
      countOfPage: 10,
      currPage: 1,
      filter_name: "",
      banks: [],
      saveAble: true,
      sr_file: "",
      sr_filename: "",
      center: { lat: 0, lng: 0 },
      // provider.sz_kycfile
      // provider.sz_ghpostgps
      provider: {
        sz_orgname: "", // sz_orgname
        sz_address: "",
        sz_providerid: "",
        sz_contactname: "",
        sz_contactphoneno: "",
        sz_contactemail: "", //sz_contactemail
        szwalletnumber: "",
        sz_bank: "",
        sz_branchid: "",
        sz_acctno: "",
        sz_geolat: "",
        sz_geolong: "",
        sz_kycfile: "",
        sz_ghpostgps: "",
        sz_alias: "",
        sz_enteredby: "",
        sz_location: "",
        szwalletprovider: "",
      },
      ban: "",
      zoom: 16,

      // center: { lat: 5.7142836, lng: 0.0746767 },
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attributionPrefix:
        "Please drag marker to your preferred location Location",
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl: false,
      },
      bounds: null,
      szbank: "",
      branches: [],
    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  methods: {
    setPage(idx) {
      if (idx <= 0 || idx > this.totalPage) {
        return;
      }
      this.currPage = idx;
    },
    removeComplaint(i) {
      this.search = "";
    },
    addSchool() {
      this.$router.push("/add");
    },
    openNav(i) {
      var x = document.getElementById("mySidenav");
      x.style.display = "block";
      this.selectedIndex = i;
    },
    closeNav() {
      var x = document.getElementById("mySidenav");
      x.style.display = "none";
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    getBanks() {
      http()
        .get("/aGetBanks/")
        .then(({ data }) => {
          this.banks = data;
        })
        .catch((err) => {
          this.$snotify.error("Could not get the list of banks");
        });
    },
    handleFileUpload() {
      let f = this.$refs.uploadFile.files[0];
      // console.log(f)
      const reader = new FileReader();

      reader.onload = (function (theFile) {
        return function (e) {
          var binaryData = e.target.result;
          //Converting Binary Data to base 64
          let base64String = window.btoa(binaryData);
          //showing file converted to base64
          document.getElementById("base64").value = base64String;
          // alert('File converted to base64 successfuly!\nCheck in Textarea');
        };
      })(f);
      // Read in the image file as a data URL.
      reader.readAsBinaryString(f);
      // // toBase64()
      this.provider.sz_kycfile = this.$refs.uploadFile.files[0].name;

      // console.log(this.sr_file)
      this.saveAble = true;
      this.$snotify.info(
        'The file "' +
          this.provider.sz_kycfile +
          '" has been selected. Please Upload',
        {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          position: "centerTop",
        }
      );
    },
    createNewSchool() {
      this.banks.forEach((el) => {
        if (el.szbankid == this.provider.sz_bank) {
          this.provider.sz_bank = el.szbankname;
          this.szbank = el.szbankname;
          // console.log(this.szbank)
        } else {
          this.szbank = "";
        }
      });
      // console.log(this.provider)
      /*sz_geolat:'',
        sz_geolong: '',*/
      if (!this.provider.sz_orgname) {
        this.$snotify.error("School Name is Missing");
        return;
      }
      if (!this.provider.sz_address) {
        this.$snotify.error("Address is Missing");
        return;
      }
      if (!this.provider.sz_alias) {
        this.$snotify.error("Alias is Missing");
        return;
      }
      /*if (!this.provider.sz_bank) {
        this.$snotify.error("Bank is Missing");
        return;
      }
      if (!this.provider.sz_branchid) {
        this.$snotify.error("Bank Branch is Missing");
        return;
      }*/
      this.provider.sz_providerid = this.providerid;
      this.provider.sz_geolat = this.center.lat;
      this.provider.sz_geolong = this.center.lng;
      this.provider.sz_enteredby = this.providerinfo.userid;
      this.$Progress.start();
      this.loading = true;

      http()
        .post("/createTemporarySchoolinfo/", this.provider)
        .then(({ data }) => {
          // console.log(data.message.reason)
          if (data.success === true) {
            this.$snotify.success(data.message.reason);
            //this.getSchooldList();
            this.$bvModal.hide("newschoolform");
            // $emit("close");
          } else if (data.success === false) {
            this.$snotify.error(data.message.reason);
          }
        })
        .catch((err) => {
          this.$snotify.error("Unexpected Error Occurred");
          this.$Progress.finish();
        })
        .finally(() => {
          this.loading = false;
          this.$Progress.finish();
        });
    },
    getLocation() {
      navigator.geolocation.getCurrentPosition(
        this.showPosition,
        this.showError
      );
    },

    showPosition(position) {
      this.center = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      //    this.getCity(this.center, this.getResponse)
      this.center = this.center;
    },
    getBraches() {
      this.$Progress.start();
      http()
        .post("/aGetBankBranches/", { szbankid: this.provider.sz_bank })
        .then(({ data }) => {
          this.branches = data;
        })
        .catch((err) => {
          this.$snotify.error("Could not get the list of branches");
        });
    },
    getBranch(value) {
      this.szbank = value.target.value;
      this.provider.sz_bank = value.target.value;
      this.getBraches();
    },
    getSchooldList() {
      this.$Progress.start();
      this.loading = true;
      http()
        .post("/ListProvidersSchools/", { sz_providerid: this.providerid })
        .then(({ data }) => {
          this.tabdata = data;
        })
        .catch((err) => {
          this.$snotify.error("Could not get the list of schools");
          this.$Progress.finish();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  computed: {
    ...mapState({
      providerid: (state) => state.provider.provider_id,
      providerinfo: (state) => state.provider,
    }),

    filteredRows: {
      get: function () {
        let search = this.search.trim().toLowerCase();
        return this.search.trim() !== ""
          ? this.tabdata.filter((d) => {
              return (
                d.sz_orgname.toLowerCase().indexOf(search) > -1 ||
                d.sz_contactemail.toLowerCase().indexOf(search) > -1 ||
                d.sz_contactphoneno.toLowerCase().indexOf(search) > -1 ||
                d.sz_contactname.toLowerCase().indexOf(search) > -1
              );
            })
          : this.tabdata;
      },
      // setter
      set: function (newValue) {
        this.tabdata = newValue;
      },
    },
    pageStart: function () {
      return (this.currPage - 1) * this.countOfPage;
    },
    totalPage: function () {
      return Math.ceil(this.filteredRows.length / this.countOfPage);
    },
    theData() {
      return this.filteredRows.slice(
        this.pageStart,
        this.pageStart + this.countOfPage
      );
    },
  },
  created() {
    this.getBanks();
    this.getLocation();
    this.getSchooldList();
  },
};
</script>

<style scoped lang="scss">
> paginate-links.items {
  user-select: none;
  a {
    cursor: pointer;
  }
  li.active a {
    font-weight: bold;
  }
  li.next:before {
    content: " | ";
    margin-right: 13px;
    color: #ddd;
  }
  li.disabled a {
    color: #ccc;
    cursor: no-drop;
  }
}
li {
  display: inline;
}

.hm-gradient {
  background-image: linear-gradient(
    to top,
    #f3e7e9 0%,
    #e3eeff 99%,
    #e3eeff 100%
  );
}
.darken-grey-text {
  color: #2e2e2e;
}
.input-group.md-form.form-sm.form-2 input {
  border: 1px solid #bdbdbd;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.input-group.md-form.form-sm.form-2 input.purple-border {
  border: 1px solid #9e9e9e;
}
.input-group.md-form.form-sm.form-2
  input[type="text"]:focus:not([readonly]).purple-border {
  border: 1px solid #ba68c8;
  box-shadow: none;
}
.form-2 .input-group-addon {
  border: 1px solid #ba68c8;
}
.danger-text {
  color: #ff3547;
}
.success-text {
  color: #00c851;
}
.table-bordered.red-border,
.table-bordered.red-border th,
.table-bordered.red-border td {
  border: 1px solid #ff3547 !important;
}
.table.table-bordered th {
  text-align: center;
}
.remove-search-btn {
  cursor: pointer;
}
.sidenav {
  height: 100%;
  display: none;
  position: fixed;
  z-index: 2;
  top: 0;
  right: 0;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  background-color: #f6f9fd;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}
.label {
  font-weight: bold;
}
</style>
